import {useQuery, gql} from 'admin/lib/apollo'
import {NumberParam, StringParam, useQueryParams, withDefault} from 'use-query-params'

export const QUERY = gql`
  query GetRepeatingInvoices(
    $fromDate: String
    $toDate: String
    $fromAmount: String
    $toAmount: String
    $q: String
    $page: Int
    $limit: Int
    $sortBy: String
    $sortDirection: String
  ) {
    repeatingInvoices(
      fromDate: $fromDate
      toDate: $toDate
      fromAmount: $fromAmount
      toAmount: $toAmount
      q: $q
      page: $page
      limit: $limit
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      collection {
        id
        nextInvoiceDate
        nextInvoiceDueDate
        frequency
        frequencyCount
        endDate
        amount
        state
        isSendable
        account {
          id
          name
          displayName @client
          contactFullName @client
          contactFirstName
          contactLastName
        }
      }
      metadata {
        totalCount
      }
    }
  }
`

export default organisationId => {
  const [filters, setFilters] = useQueryParams({
    q: withDefault(StringParam, ''),
    fromDate: withDefault(StringParam, ''),
    toDate: withDefault(StringParam, ''),
    fromAmount: withDefault(StringParam, ''),
    toAmount: withDefault(StringParam, ''),
    sortBy: withDefault(StringParam, 'next_invoice_date'),
    sortDirection: withDefault(StringParam, 'desc'),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 50),
    sortLabel: withDefault(StringParam, 'Next invoice date')
  })

  const variables = {organisationId, ...filters}
  const {data, error: getError} = useQuery(QUERY, {variables})
  const response = data ? data.repeatingInvoices : []

  return {
    filters,
    setFilters,
    errors: getError || {},
    repeatingInvoices: response.collection || [],
    totalCount: response.metadata ? response.metadata.totalCount : 0
  }
}
